import { Category, ParsedProductPreview } from 'src/types/marketplace';
import { getFiltersForCards } from 'src/utils/marketplace/filter';

import { SITE_MARKETPLACE_URL } from './paths';
import { sortCategories } from './sorting';

export const getTabsCategories = (
  products: ParsedProductPreview[],
  categories: Category[],
) =>
  sortCategories(
    categories
      .map((category) => {
        const cardsInCategory = products.filter(
          (p) => p.category === category.type,
        );

        return {
          ...category,
          slug: category.type,
          cards: cardsInCategory,
          availableFilters: getFiltersForCards(cardsInCategory),
        };
      })
      .filter((category) => category.cards.length),
  );

export const getCategoryBreadcrumbs = (categoryTitle?: string) =>
  categoryTitle
    ? [
        {
          title: 'Главная',
          link: '/',
        },
        {
          title: 'Маркетплейс',
          link: SITE_MARKETPLACE_URL,
        },
        {
          title: categoryTitle,
          link: '',
        },
      ]
    : [
        {
          title: 'Главная',
          link: '/',
        },
        {
          title: 'Маркетплейс',
          link: '',
        },
      ];
